module.exports = __webpack_public_path__ + "static/media/pin_antique_brass.84de7386.png";